import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path1/layouts/default.vue").then(m => m.default || m))
}